<template>
    <Head title="Account Closed" />
    <div
        class="px-4 md:px-8 flex items-center justify-center min-h-screen bg-gray-100 dark:bg-slate-900"
    >
        <div class="max-w-md w-full p-6 bg-white dark:bg-slate-800 rounded-lg shadow-md dark:shadow-slate-900/50">
            <div class="text-center">
                <svg
                    class="mx-auto h-12 w-12 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                </svg>
                <h2 class="mt-2 text-lg font-medium text-gray-900 dark:text-gray-100">
                    Account Closed
                </h2>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                    Your account has been successfully closed. Thank you for
                    using our service.
                </p>
                <div class="mt-6">
                    <Link
                        href="/"
                        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Return to Homepage
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';

defineOptions({
    layout: null, // No layout for this page
});
</script>
